import React from "react";
import PropTypes from "prop-types";
import styles from "./bigScreen.less";

function CommonTemplate(props) {
  const { model, getLangMsg, data } = props
  const {
    BizModelTemp = 0, // 业务单据模板
    SysModelTemp = 0, // 系统单据模板 
    WorkflowTemp = 0, // 流程模板
    WorkflowNodeTemp = 0, // 流程节点模板
    PrintTemp = 0 // 打印模板
  } = data || {}
  return (
    <div className={styles.commonTemplate}>
      <div className={styles.commonTemplateWrapper}>
        <div className={styles.itemContainer}>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{BizModelTemp}</div>
            <div className={styles.itemText} title={getLangMsg('commonTemplate.key0001')}>{getLangMsg('commonTemplate.key0001')}</div>
            <div className={styles.itemIcon}></div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{SysModelTemp}</div>
            <div className={styles.itemText} title={getLangMsg('commonTemplate.key0002')}>{getLangMsg('commonTemplate.key0002')}</div>
            <div className={styles.itemIcon}></div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{WorkflowTemp}</div>
            <div className={styles.itemText} title={getLangMsg('commonTemplate.key0003')}>{getLangMsg('commonTemplate.key0003')}</div>
            <div className={styles.itemIcon}></div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{WorkflowNodeTemp}</div>
            <div className={styles.itemText} title={getLangMsg('commonTemplate.key0004')}>{getLangMsg('commonTemplate.key0004')}</div>
            <div className={styles.itemIcon}></div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{PrintTemp}</div>
            <div className={styles.itemText} title={getLangMsg('commonTemplate.key0005')}>{getLangMsg('commonTemplate.key0005')}</div>
            <div className={styles.itemIcon}></div>
          </div>
        </div>
        <div className={styles.commonTemplateTitle}>
            <div className={styles.titleLeftIcon}></div>
            <div className={styles.titleText} title={getLangMsg('commonTemplate.key0006')}>{getLangMsg('commonTemplate.key0006')}</div>
            <div className={styles.titleRightIcon}></div>
        </div>
      </div>
    </div>
  );
}
CommonTemplate.propTypes = {
  baseinfo: PropTypes.object,
  name: PropTypes.string,
};
export default CommonTemplate;
